import { useDispatch } from "react-redux";
import DuplicateDefinitionLookupFields from "./DuplicateDefinitionLookupFields";
import DuplicateDefinitionRowFiltering from "./DuplicateDefinitionRowFiltering";
import { useSelector } from "react-redux";
import { setInitialDuplicateData } from "../../../../../features/uniqueDefSlice";
import { useEffect, useRef, useState } from "react";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { Paper } from "@mui/material";

const DuplicateDefinition = ({ onRegisterForceRefresh }: any) => {
  const dispatch = useDispatch();

  const {
    loading,
    uniqueDefinitionDataAll,
    dupID,
    // initialDuplicateData,
  } = useSelector((state: any) => state.uniqueDefinition);

  const [, /*showLookupFieldsEdit*/ setShowLookupFieldsDuplicate] =
    useState(false);

  const lookupRef = useRef<any>(null);
  const rowFilteringRef = useRef<any>(null);

  useEffect(() => {
    onRegisterForceRefresh(() => async () => {
      const filteringPayload = rowFilteringRef.current?.refresh() ?? null;
      const lookupPayload = lookupRef.current?.refresh() ?? null;

      return {
        filteringPayload,
        lookupPayload,
      };
    });
  }, [onRegisterForceRefresh]);

  useEffect(() => {
    if (dupID && uniqueDefinitionDataAll?.length > 0) {
      const matched = uniqueDefinitionDataAll.find(
        (item: any) => item.id === Number(dupID),
      );
      if (matched) {
        dispatch(setInitialDuplicateData(matched));
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dupID, uniqueDefinitionDataAll]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper style={{ margin: "15px" }}>
            <DuplicateDefinitionRowFiltering
              setShowLookupFieldsDuplicate={setShowLookupFieldsDuplicate}
              ref={rowFilteringRef}
            />
          </Paper>
          <Paper style={{ margin: "15px" }}>
            <DuplicateDefinitionLookupFields ref={lookupRef} />
          </Paper>
        </>
      )}
    </>
  );
};

export default DuplicateDefinition;
